export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12097.3e67fac3.jpg";